module.exports = __webpack_public_path__ + "media/images/edion/popular/4-dfc8a2fd777e7b1e12560e66faf233bb.png";